import React from "react";
import EventFooter from "../components/Event/EventFooter";
import PostPreview from "../components/Post/Preview";

export function PostPage() {
  return (
    <React.Fragment>
      <main className="events-page-post events6ix-layout-page" role="main">
        <div className="events6ix-layout-page-content events6ix-layout-page-content-space-top">
          <PostPreview />
        </div>
      </main>
      <EventFooter />
    </React.Fragment>
  );
}
